export class ContactModel {
    slo: string;
    name: string;
    email: string;
}